import { apiFetch } from '../client';

/** E-cheqs recibidos como pago (AR). Server: server/src/routes/echeqs.ts. */

export type EcheqEstado =
  | 'Pendiente Autorizacion'
  | 'Autorizado'
  | 'Rechazado'
  | 'Acreditado'
  | 'Rechazado Banco'
  /** Su cobro se anuló por fuera de la bandeja. */
  | 'Anulado';

export type Echeq = {
  id: string;
  estado: EcheqEstado;
  nroCheque: string;
  bancoEmisor: string;
  cuitLibrador: string;
  /** yyyy-mm-dd */
  fechaPago: string;
  monto: number;
  motivoRechazo: string | null;
  autorizadoPor: string | null;
  autorizadoAt: string | null;
  cajaAcreditacion: string | null;
  fechaAcreditacion: string | null;
  solicitante: string | null;
  creadoAt: string;
  comprobanteId: string | null;
  comprobanteStatus: string | null;
  comprobanteDriveItemId: string | null;
  comprobanteFileName: string | null;
  ventaId: string | null;
  cliente: string | null;
  ventaStatus: string | null;
  vendedor: string | null;
};

/** Todas las queries de E-cheqs cuelgan de esta clave (invalidar = refrescar todo). */
export const ECHEQS_QUERY_KEY = ['echeqs'] as const;

export async function listEcheqs(params: { estado?: EcheqEstado[]; ventaId?: string } = {}): Promise<Echeq[]> {
  const q = new URLSearchParams();
  if (params.estado?.length) q.set('estado', params.estado.join(','));
  if (params.ventaId) q.set('ventaId', params.ventaId);
  const res = await apiFetch<{ items: Echeq[] }>(`/api/echeqs${q.size ? `?${q}` : ''}`);
  return res.items;
}

/** Venta con E-cheqs sin cobrar del todo. Server: lib/echeqs.ts `saldosEcheq`. */
export type SaldoEcheq = {
  ventaId: string;
  status: string;
  /** Moneda de la venta (total y cobrado van en ella). */
  moneda: string;
  /** null para el perfil mantenimiento (sólo ve los %). */
  total: number | null;
  cobrado: number | null;
  pctCobrado: number;
  pctRequerido: number;
  /** En Pendiente Despacho con lo cobrado por debajo del %: no se puede despachar. */
  retenido: boolean;
};

export const listSaldosEcheq = async (): Promise<SaldoEcheq[]> =>
  (await apiFetch<{ items: SaldoEcheq[] }>('/api/echeqs/saldos')).items;

export const autorizarEcheq = (id: string) =>
  apiFetch<{ ok: true }>(`/api/echeqs/${id}/autorizar`, { method: 'POST', body: {} });

export const rechazarEcheq = (id: string, motivo: string) =>
  apiFetch<{ ok: true }>(`/api/echeqs/${id}/rechazar`, { method: 'POST', body: { motivo } });

export const acreditarEcheq = (id: string, caja: string) =>
  apiFetch<{ ok: true; statusRO: string | null }>(`/api/echeqs/${id}/acreditar`, {
    method: 'POST',
    body: { caja },
  });

export const rechazoBancoEcheq = (id: string, motivo: string) =>
  apiFetch<{ ok: true }>(`/api/echeqs/${id}/rechazo-banco`, { method: 'POST', body: { motivo } });

/** Etiqueta corta para chips/badges. */
export const ESTADO_ECHEQ_LABEL: Record<EcheqEstado, string> = {
  'Pendiente Autorizacion': 'Pendiente autorización',
  Autorizado: 'En cartera',
  Rechazado: 'Rechazado',
  Acreditado: 'Acreditado',
  'Rechazado Banco': 'Rechazado por el banco',
  Anulado: 'Cobro anulado',
};
